module.exports = __webpack_public_path__ + "media/student_contributors/06KaylenPhillips-969c4cac.png";